import { PREFIX as s } from "../constants/site.js";
class i {
  prefixFirstClassName(t) {
    if (!t)
      return "";
    const r = t.trim().split(/\s+/);
    return r.length ? (r[0] = `${s}-${r[0]}`, r.join(" ")) : "";
  }
  prefixAllClassNames(t) {
    if (!t)
      return "";
    const r = t.trim().split(/\s+/);
    return r.length ? r.map((e) => `${s}-${e}`).join(" ") : "";
  }
}
const a = new i();
export {
  a as default
};
